/*
 * @Author: niyingfeng
 * @Date: 2022-03-11 15:12:50
 * @LastEditors: niyingfeng
 * @LastEditTime: 2022-03-11 17:33:47
 * @FilePath: /cheese/web/src/public/apis/http.js
 * @Description: 新建简版aixos实例
 * 
 */
import axios from 'axios';
import { BASE_URL,  COLOR} from '@config';

const instance = axios.create({
    baseURL: BASE_URL,
    withCredentials: true,
    headers: COLOR ? { 'x1-bilispy-color': COLOR } : {}
})

export default instance